<div [class]="'common-status-message__g-container-'+type">
  <i [class]="adviceMessage.icon+' common-status-message__icon-md'"></i>
  <div class="common-status-message__g-content">
    <div class="common-status-message__g-icon-text-content">
      <div class="common-status-message__g-title-subtitle">
        <span class="common-status-message__g-subtitle">{{text | afTranslate}}</span>
      </div>
      @if(showCloseButton){
        <button class="common-button__icon-xs-noborder"
          (click)="closeBox()">
          <i class="lf-icon-close-thick common-icon__sm"></i>
        </button>
      }
    </div>
  </div>
</div>
